import { ReactNode } from "react";
import { LucideIcon } from "lucide-react";
import { AnimatedCount } from "@/components/ui/animated-count";
import { Skeleton } from "@/components/ui/skeleton";

interface MetricCardProps {
  icon: LucideIcon;
  label: string;
  value: number;
  loading?: boolean;
  children?: ReactNode;
}

export function MetricCard({ icon: Icon, label, value, loading = false, children }: MetricCardProps) {
  return (
    <div className="flex items-center gap-3">
      <div className="bg-primary/10 flex h-10 w-10 items-center justify-center rounded-lg">
        <Icon className="text-primary h-5 w-5" />
      </div>
      <div>
        <p className="text-muted-foreground text-xs font-medium">{label}</p>
        {loading ? (
          <Skeleton className="mt-1 h-6 w-8" />
        ) : children ? (
          children
        ) : (
          <p className="text-2xl font-bold tabular-nums">
            <AnimatedCount target={value} />
          </p>
        )}
      </div>
    </div>
  );
}
